import { render, staticRenderFns } from "./recordDialog.vue?vue&type=template&id=219ed6d4&scoped=true"
import script from "./recordDialog.vue?vue&type=script&lang=js"
export * from "./recordDialog.vue?vue&type=script&lang=js"
import style0 from "./recordDialog.vue?vue&type=style&index=0&id=219ed6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ed6d4",
  null
  
)

export default component.exports